import EmojiRatingPage from "@components/EmojiRatingPage"

export default function HomeSpaceConfidencePage() {
  return (
    <EmojiRatingPage
      translationKey="homeSpaceConfidence"
      leftLabelKey="leftLabel"
      rightLabelKey="rightLabel"
    />
  )
}
